module.exports = __webpack_public_path__ + "img/footer_co1.49ae0dd8.png";